import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/router";
import { I18nextProvider } from "react-i18next";
import i18n from "@/i18n";
import useScrollToTop from "@/hooks/useScrollToTop";
import SiteMetadata from "@/components/feature/SiteMetadata";
import CookieConsent from "@/components/feature/CookieConsent";

function ScrollToTopWrapper() {
  useScrollToTop();
  return null;
}

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTopWrapper />
        <SiteMetadata />
        <AppRoutes />
        <CookieConsent />
      </BrowserRouter>
    </I18nextProvider>
  );
}
